
import { Component, Prop, Vue } from "vue-property-decorator";
import { mdiPencil } from "@mdi/js";
import { TranslateResult } from "vue-i18n";
import ResponsiveBtn from "@/components/generic/buttons/responsive-btn.vue";

@Component({
  components: { ResponsiveBtn },
})
export default class EditBtn extends Vue {

  @Prop({default: ""})
  public label: string|TranslateResult;

  @Prop({default: false})
  public disabled: boolean;

  private icons = {
    mdiPencil,
  };

  get defaultLabel(): TranslateResult {
    return this.$t("actions.edit");
  }
}
